import {getEffect} from 'effects/EffectsList.js';

export default superclass => class extends superclass  {

    effect = undefined;
    
    useEffect(effect) {
        if (this.effect) {
            // in this case we are replacing this effect w a new one
            // so we must dispose
            this.effect.dispose();
        }
        this.effect = effect;
        this.effect.registerContext(this.context);

        // hook up the formant to effect
        this.formantGain.disconnect();
        this.formantGain.connect(this.effect.effectNode);
        this.effect.connect(this.output);
    }

    bypassEffect() {
        if (!this.effect) {
            return;
        }

        this.effect.dispose();
        this.effect = undefined;
        this.formantGain.disconnect();
        this.formantGain.connect(this.output);
    }

    async loadEffectFromJson(json) {
        if (this.effect && json.name === this.effect.name) {
            // it's the same effect, so we can reuse it
            this.effect.fromJson(json, [], 0);
        } else {
            let ret = getEffect(json, [], this.oscillator.instrument.sequencerEngine, 0);
            this.useEffect(ret.effect);
        }
    }
}
